import { useState, useEffect } from 'react';

const useDebounce = (value, delay, deps = []) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, ...deps]);
  return debouncedValue;
};

export default useDebounce;
